import { render, staticRenderFns } from "./ReviewAppointment.vue?vue&type=template&id=8d279bd8&scoped=true&"
import script from "./ReviewAppointment.vue?vue&type=script&lang=js&"
export * from "./ReviewAppointment.vue?vue&type=script&lang=js&"
import style0 from "./ReviewAppointment.vue?vue&type=style&index=0&id=8d279bd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d279bd8",
  null
  
)

export default component.exports